<template>
  <div class="j-step-wrap" :style="{ '--j-step-circle-color': circleColor }">
    <div class="j-step-side"><i/></div>
    <div class="j-step-body">
      <div class="j-step-title">
        <div class="j-step-title_content">
          {{title}}
          <slot name="title" />
          <i v-if="required" class="j-step-title-require">*</i>
        </div>
      </div>
      <div class="j-step-content">
        <div v-if="description">{{description}}</div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JStep",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    circleColor: {
      type: String,
      default: "#126CFD"
    }
  }
}
</script>

<style lang="scss">
:is(.j-step-wrap) {
  &:last-child {
    ::after {
      visibility: hidden;
    }
  }
}
  .j-step-wrap {
    --j-step-circle-color: #126CFD;
    display: flex;
    .j-step-side {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 20px;
      background: #fff;
      > i {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 7px 0;
        background: #fff;

        &::before {
          content: "";
          width: 9px;
          height: 9px;
          border: 2px solid var(--j-step-circle-color);
          border-radius: 50%;
          box-sizing: border-box;
          background: #fff;
        }
      }
      &::after {
        content: "";
        width: 1px;
        height: 100%;
        border-right: 1px dashed #E5E6EB;
        box-sizing: border-box;
        background: #fff;
      }
    }
    .j-step-body {
      flex: 1;
      min-width: 10px;
      .j-step-title {
        display: flex;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #15181E;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        background: #fff;

        .j-step-title_content {
          display: inline-flex;
          flex: 1;
          min-width: 10px;
        }

        .j-step-title-require {
          color: #DE0A0A;
        }
      }

      .j-step-content {
        overflow: hidden;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: rgba(21,24,30,0.3);
        line-height: 20px;
        text-align: left;
        font-style: normal;
        padding: 8px 0;
      }
    }
  }
</style>